/**
 * Maps a MuviHub cart `totals`/`newTotals` object into the legacy
 * `calculatedValues` field names the rest of the app already reads.
 * Points-related fields have no equivalent in the new model and are
 * treated as if the "sem pontos" payment option was selected (always 0).
 */
export function mapCartTotals(totals = {}) {
	const totalConvenienceFee = totals.totalServiceCharge || 0
	const totalServiceFee = totals.totalFees || 0
	const totalToll = totals.totalTolls || 0

	return {
		...totals,
		totalFare: totals.totalFare || 0,
		totalConvenienceFee,
		totalServiceFee,
		totalToll,
		// "Taxa de Serviço" (totalConvenienceFee) is shown as its own line —
		// don't double-count it here, this is only tolls + generic fees.
		totalFeeSummary: totalServiceFee + totalToll,
		totalInsuranceValue: totals.totalInsurance || 0,
		totalDiscount: totals.totalDiscount || 0,
		// O carrinho da MuviHub retorna o tipo do desconto vencedor em
		// `discountType` (enum DiscountType do backend) em vez do antigo
		// booleano `hasFamilyDiscount` da API de cálculo de preço.
		hasFamilyDiscount: totals.discountType === 'DESCONTO FAMILIA',
		totalOrderValue: totals.totalPayable || 0,
		totalInterest: totals.totalInterestCharges || 0,
		totalOther: 0,
		totalBpeValue: 0,
		totalPointsBpe: 0,
		totalPointsForConvenienceFee: 0,
		totalInsurancePoints: 0,
		totalPointsUsed: 0,
	}
}

/**
 * Fills in the per-ticket fields that used to come from the now-removed
 * price calculation endpoint; everything else a selected seat needs
 * (originCity, destinationCity, tripDate, busClass, ...) is already present
 * on the seat objects built while booking it.
 */
export function enrichTicket(seat) {
	return {
		...seat,
		// `fare` here is what bus-seat-selection-modal-resume shows next to
		// each seat — the seat's own total (fare + fees - discount), not the
		// bare base fare.
		fare: seat.price && seat.price.value,
		bpePointsUsed: 0,
		isPromotionalSeat: !!(seat.discountForPromotionBusSeat > 0),
	}
}
